<template>
	<v-card :style="{ padding: surveyTypeQuiz ? '' : '20px' }" class="rating-survey elevation-0">
		<div class="rating-survey__content d-flex justify-center">
			<v-rating
				color="#FFBC03"
				:size="40"
				:ripple="false"
				v-model="internalValue"
				:hover="!internalValue"
			/>
		</div>
	</v-card>
</template>
<script>
export default {
	props: {
		value: {
			type: Number,
			default: 0,
		},
		surveyTypeQuiz: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		internalValue: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
}
</script>
<style lang="scss">
.rating-survey {
	font-family: Inter, sans-serif;
	user-select: none;

	&__content {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}

	&__name {
		font-size: 18px;
		font-weight: 700;
		color: var(--username-category-title);
		line-height: 21.94px;
		padding: 0 !important;
		display: flex;
		justify-content: center;
	}

	&__total {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--accent-color);

		@media (max-width: 480px) {
			font-size: 16px;
		}
	}

	&__count {
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
		color: #9b9b9b;

		@media (max-width: 480px) {
			font-size: 12px;
		}
	}

	.v-rating {
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
	}
	.v-rating .v-icon {
		padding: 0 !important;
	}

	.accent--text::before {
		color: #e2e2e2 !important;
	}
}
</style>
